// Activity log for the Web Changes module — the audit trail of who did what
// TO the changelog (distinct from the change rows themselves). Mirrors the
// vault's vaultActivityLog shape. In this frontend-first phase entries live in
// local state; the backend phase swaps makeEntry()'s caller to a bare
// aws.from('web_change_activity').insert() (like poActivityLog.js).

// action_type → verb phrase, rendered as: <who> <phrase> <target> · <detail>
export const ACTION_PHRASES = {
  change_created: 'logged a change on',
  change_edited: 'edited a change on',
  change_archived: 'archived a change on',
  project_created: 'added the project',
  project_edited: 'edited the project',
  project_deactivated: 'deactivated the project',
};

export function phraseFor(actionType) {
  return ACTION_PHRASES[actionType] || (actionType || '').replace(/_/g, ' ');
}

let _seq = 0;
// Build an activity entry from a mutation. `target` is the human subject
// (project name, or an action snippet); `detail` is optional extra context.
export function makeEntry(session, { action_type, target, detail, project_id }) {
  _seq += 1;
  return {
    id: `act-${Date.now()}-${_seq}`,
    action_type,
    target: target || null,
    detail: detail || null,
    project_id: project_id || null,
    actor_code: session?.code || null,
    actor_name: session?.name || 'Someone',
    created_at: new Date().toISOString(),
  };
}
